import { Checkbox, FormControlLabel, Grid, Switch, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React from 'react';

import { Study } from 'interfaces/study';
import { DefaultStainTypeSelection } from './DefaultStainTypeSelection';

export const defaultStudySlideViewMode = 'single';

export const GeneralSettings: React.FC<
  React.PropsWithChildren<{
    studyId: Study['id'];
    updatedSettings: Study['settings'];
    setUpdatedSettings: React.Dispatch<React.SetStateAction<Study['settings']>>;
    editable?: boolean;
  }>
> = ({ studyId, updatedSettings, setUpdatedSettings, editable = true }) => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Default Slide Viewing Mode</Typography>
      </Grid>
      <Grid item xs={8}>
        <ToggleButtonGroup
          disabled={!editable}
          size="small"
          color="primary"
          value={updatedSettings.defaultSlideViewMode || defaultStudySlideViewMode}
          exclusive
          onChange={(_, newViewMode) =>
            setUpdatedSettings((prevSettings) => ({ ...prevSettings, defaultSlideViewMode: newViewMode }))
          }
          aria-label="Slide-Default-View-Mode"
        >
          <ToggleButton value="single">Single</ToggleButton>
          <ToggleButton value="side-by-side">Side-By-Side</ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Default Staining Type</Typography>
      </Grid>
      <Grid item xs={12}>
        <DefaultStainTypeSelection
          studyId={studyId}
          updatedSettings={updatedSettings}
          setUpdatedSettings={setUpdatedSettings}
          editable={editable}
        />
      </Grid>

      <Grid item xs={8}>
        <FormControlLabel
          label="Use legacy viewer (without vector data, annotations, 16bit support...)"
          control={
            <Checkbox
              disabled={!editable}
              checked={Boolean(updatedSettings.useOSDViewer)}
              onChange={(e) =>
                setUpdatedSettings((prevSettings) => ({
                  ...prevSettings,
                  useOSDViewer: e.target.checked,
                }))
              }
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          label="Artifact details"
          control={
            <Switch
              disabled={!editable}
              checked={updatedSettings?.artifactDetailsEnabled === true}
              onChange={(event) =>
                setUpdatedSettings((prevSettings) => ({
                  ...prevSettings,
                  artifactDetailsEnabled: event.target.checked,
                }))
              }
              inputProps={{ 'aria-label': 'Artifact details' }}
            />
          }
        />
        <Typography variant="body2" color="text.secondary">
          Allow artifact tables and up to 10 additional cell details on hover. Enable only for studies that need the
          extra parquet reads.
        </Typography>
      </Grid>
    </Grid>
  );
};
